import { ServiceBase } from '../../../../core/services/ServiceBase'
import Proxy from './Proxy'

class Service extends ServiceBase {
  getHighlight(params) {
    return this.getData(() => Proxy.getHighlight(params))
  }

  getOverdueTaxDebt(params) {
    return this.getData(() => Proxy.getOverdueTaxDebt(params))
  }

  getOverdueSocialInsurance(params) {
    return this.getData(() => Proxy.getOverdueSocialInsurance(params))
  }

  exportOverdueTaxDebt(params) {
    return this.getFileDownload(() => Proxy.exportOverdueTaxDebt(params))
  }

  exportOverdueSocialInsurance(params) {
    return this.getFileDownload(() =>
      Proxy.exportOverdueSocialInsurance(params),
    )
  }
}

export default new Service()
